<template>
  <pt-order-detail class="pt-order-detail__page" :id="id" :operation="operation"></pt-order-detail>
</template>

<script>
import PtOrderDetail from 'cps/goods-order/pt-order-detail/withData'
export default {
  name: 'pt-order-detail__view',
  props: {
    id: {
      type: String,
      default: ''
    },
    operation: {
      type: String,
      default: ''
    }
  },
  components: {
    'pt-order-detail': PtOrderDetail
  }
}
</script>
